import { Reveal, SectionLabel } from "../Reveal";
import { RegistrationForm } from "../RegistrationForm";
import { BONUSES, ASSETS } from "../../content";

const TRUST = [
  "100% free educational briefing — nothing sold",
  "No credit pull required to register or attend",
  "Live Q&A — ask about your own situation",
  "Optional next steps only. No obligation, ever",
];

export const FinalCTA = ({ attribution }) => (
  <section id="register" className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24 overflow-hidden bg-white/[0.015]" data-testid="final-registration-section">
    <div
      className="absolute left-0 top-1/2 -translate-y-1/2 w-[700px] h-[700px] pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(254,0,0,0.10) 0%, transparent 65%)" }}
      aria-hidden="true"
    />
    <div className="relative grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <Reveal><SectionLabel num="009" text="FINAL CALL" /></Reveal>
        <Reveal delay={0.05}>
          <h2 className="serif font-black uppercase tracking-[-0.02em] text-[clamp(36px,4.6vw,64px)] text-white" style={{ lineHeight: 0.97 }} data-testid="final-h2">
            YOUR NEXT MOVE STARTS WITH A CLEARER <span className="text-[#FE0000]">MAP.</span>
          </h2>
        </Reveal>
        <div className="mt-10 space-y-4">
          {TRUST.map((t, i) => (
            <Reveal key={i} delay={0.1 + i * 0.05}>
              <div className="flex gap-4 text-[17px] text-white" data-testid={`trust-bullet-${i}`}>
                <span className="text-[#FE0000] font-bold shrink-0">✓</span>
                {t}
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="flex items-center gap-5 mt-12">
            <img
              src={ASSETS.eagle}
              alt="U.S. Lending Partner eagle mascot holding the keys"
              className="w-36 h-36 object-cover object-top rounded-xl border border-[#20416F] bg-white"
              data-testid="eagle-mascot"
            />
            <p className="mono text-[13px] tracking-[0.25em] text-white leading-relaxed max-w-[220px]">
              THE KEYS ARE CLOSER THAN YOU THINK.
            </p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <div className="rounded-xl border border-white/10 bg-[#132441]/75 backdrop-blur-xl p-6 sm:p-8 max-w-md mx-auto lg:ml-auto w-full" data-testid="final-registration-card">
          <div className="mono text-[13px] tracking-[0.35em] text-[#FFC631]">SECURE YOUR SEAT</div>
          <h3 className="serif text-xl font-black uppercase tracking-tight text-white mt-3 mb-4">
            Register Free — Priority Access
          </h3>
          <ul className="mb-5 space-y-2">
            {BONUSES.slice(0, 3).map((b, i) => (
              <li key={i} className="flex gap-3 text-[15px] text-white leading-snug">
                <span className="text-[#FE0000] shrink-0">✓</span>
                {b}
              </li>
            ))}
            <li className="mono text-[13px] text-white tracking-wider pl-6">+ 2 MORE BONUSES AT REGISTRATION</li>
          </ul>
          <RegistrationForm attribution={attribution} variant="final" />
        </div>
      </Reveal>
    </div>
  </section>
);
